"use strict";
angular.module('hiddenCodeManagementRouterModule', []).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", { //个人中心管理模块
        url: '/classifymanagement?classifyid&classifypath',
        views: {
            'main@manageconfig.sysmanage.hiddencodemanagement': {
                templateUrl: './manageConfig/sysManageMent/hiddenCodeManagement/classifyManagement/classifyManagement_tpl.html',
                controller: "hClassifyManagementCtrl"
            }
        }
    }).state("manageconfig.sysmanage.hiddencodemanagement.eventmanagement", { //个人中心管理模块
        url: '/eventmanagement',
        views: {
            'main@manageconfig.sysmanage.hiddencodemanagement': {
                templateUrl: './manageConfig/sysManageMent/hiddenCodeManagement/eventManagement/eventManagement_tpl.html',
                controller: "hEventManagementCtrl"
            }
        }
    }).state("manageconfig.sysmanage.hiddencodemanagement.stopevent", { //个人中心管理模块
        url: '/stopevent',
        views: {
            'main@manageconfig.sysmanage.hiddencodemanagement': {
                templateUrl: './manageConfig/sysManageMent/hiddenCodeManagement/stopEvent/stopEvent_tpl.html',
                controller: "hStopEventCtrl"
            }
        }
    }).state("manageconfig.sysmanage.hiddencodemanagement.eventmanagement.editevent", { //个人中心管理模块
        url: '/editevent?eventinfo',
        views: {
            'main@manageconfig.sysmanage.hiddencodemanagement.eventmanagement': {
                templateUrl: './manageConfig/sysManageMent/hiddenCodeManagement/eventManagement/editEvent/editEvent_tpl.html',
                controller: "hEditEventCtrl"
            }
        }
    });
}]);